export enum BusinessError {
	//Souscriptions
	WALLET_INVALID = 'WALLET_INVALID',
	LEGAL_PERSON_IR = 'LEGAL_PERSON_IR',
	DEFISC_IRPP_UNAVAILABLE = 'DEFISC_IRPP_UNAVAILABLE',
	LEGAL_PERSON_APPORT_CESSION = 'LEGAL_PERSON_APPORT_CESSION',
	DEFISC_APPORT_CESSION_UNAVAILABLE = 'DEFISC_APPORT_CESSION_UNAVAILABLE',
	COUNTRY_NOT_ALLOWED = 'COUNTRY_NOT_ALLOWED',
	PAYMENT_TYPE_NOT_ALLOWED = 'PAYMENT_TYPE_NOT_ALLOWED',
	PAYMENT_CARD_OVER_5000 = 'PAYMENT_CARD_OVER_5000',
	LEGAL_PERSON_PEA = 'LEGAL_PERSON_PEA',
	PAYMENT_CHECK_UNDER_5000 = 'PAYMENT_CHECK_UNDER_5000',
	INCORRECT_AMOUNT = 'INCORRECT_AMOUNT',
	ACCOUNT_NOT_FULLY_REGISTERED = 'ACCOUNT_NOT_FULLY_REGISTERED',
	ACCOUNT_NOT_LEGAL_AGE = 'ACCOUNT_NOT_LEGAL_AGE',
	ACCOUNT_DOCUMENTS_OUTDATED = 'ACCOUNT_DOCUMENTS_OUTDATED',
	ACCOUNT_DOCUMENTS_NOT_YET_VALID = 'ACCOUNT_DOCUMENTS_NOT_YET_VALID',
	ACCOUNT_NOT_ALLOWED = 'ACCOUNT_NOT_ALLOWED',
	PREMIUM_ONLY = 'PREMIUM_ONLY',
	NATURAL_PERSON_ONLY = 'NATURAL_PERSON_ONLY',
	LEGAL_PERSON_ONLY = 'LEGAL_PERSON_ONLY',
	HOUSING_TAX_UNAVAILABLE = 'HOUSING_TAX_UNAVAILABLE',
	ACCOUNT_BLOCKED = 'ACCOUNT_BLOCKED',
	ACCOUNT_BLOCKED_DATE = 'ACCOUNT_BLOCKED_DATE',
	DEPARTMENT_NOT_ALLOWED = 'DEPARTMENT_NOT_ALLOWED',
	FUNDING_NOT_OPEN = 'FUNDING_NOT_OPEN',
	MAX_AMOUNT_REACHED = 'MAX_AMOUNT_REACHED',
	MAX_AMOUNT_LEFT = 'MAX_AMOUNT_LEFT',
	MAX_AMOUNT_PREMIUM_LEFT = 'MAX_AMOUNT_PREMIUM_LEFT',
	NO_INTENTION_QUEUE = 'NO_INTENTION_QUEUE',
	CAN_NOT_CHANGE_INTENTION_QUEUE = 'CAN_NOT_CHANGE_INTENTION_QUEUE',
	ELAPSED_TIME = 'ELAPSED_TIME',
	NOT_YOUR_TURN_IN_QUEUE = 'NOT_YOUR_TURN_IN_QUEUE',
	ALREADY_PAID = 'ALREADY_PAID',
	INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
	ID_EXPIRED = 'ID_EXPIRED',
	KYC_OUTDATED = 'KYC_OUTDATED',
	INCOMPLETE_PROFILE = 'INCOMPLETE_PROFILE',

	// Compte / Patch / KYC
	CANNOT_CHANGE_IDENTITY = 'CANNOT_CHANGE_IDENTITY',
	PROOF_OF_ADDRESS_MISSING = 'PROOF_OF_ADDRESS_MISSING',
	CANNOT_CHANGE_LEGAL_PERSON_PROFILE = 'CANNOT_CHANGE_LEGAL_PERSON_PROFILE',
	ID_AND_PASSEPORT_NOT_DIFFERENT = 'ID_AND_PASSEPORT_NOT_DIFFERENT',
	OBJECTIVES_B7_BAD_ANSWER = 'OBJECTIVES_B7_BAD_ANSWER',
	FINANCIAL_SITUATION_E5_BAD_ANSWER = 'FINANCIAL_SITUATION_E5_BAD_ANSWER',
	FINANCIAL_SITUATION_E6_BAD_ANSWER = 'FINANCIAL_SITUATION_E6_BAD_ANSWER',
	UNREADABLE_FILE = 'UNREADABLE_FILE',
	FRONT_AND_BACK_FILES_NOT_DIFFRENT = 'FRONT_AND_BACK_FILES_NOT_DIFFRENT',
	CANNOT_CHANGE_LEGAL_PERSON_INFOS = 'CANNOT_CHANGE_LEGAL_PERSON_INFOS',
	CANNOT_CHANGE_KNOWLEDGE = 'CANNOT_CHANGE_KNOWLEDGE',
	MISSING_FRONT_FILE = 'MISSING_FRONT_FILE',
	CANNOT_SEND_DOCUMENT = 'CANNOT_SEND_DOCUMENT',
	EMAIL_ALREADY_USED = 'EMAIL_ALREADY_USED',
	OLD_PASSWORD_WRONG = 'OLD_PASSWORD_WRONG',
	FORCE_UPDATE_PASSWORD = 'FORCE_UPDATE_PASSWORD',
	MISSING_2FA = 'MISSING_2FA',
	PASSWORD_WITH_PERSONAL_INFOS = 'PASSWORD_WITH_PERSONAL_INFOS',
	NAME_MISSING = 'NAME_MISSING',
	KYC_PSI_OPC_OUTDATED = 'KYC_PSI_OPC_OUTDATED',
	KYC_PSI_OC_OUTDATED = 'KYC_PSI_OC_OUTDATED',
	KYC_PSI_TP_OUTDATED = 'KYC_PSI_TP_OUTDATED',
	KYC_PSFP_OUTDATED = 'KYC_PSFP_OUTDATED',
	KYC_PSFP_FOR_OC = 'KYC_PSFP_FOR_OC',
	KYC_PSI_OUTDATED = 'KYC_PSI_OUTDATED',
	FISCAL_ADDRESS = 'FISCAL_ADDRESS',
	EXPIRED_TOKEN = 'EXPIRED_TOKEN',

	// WALLET
	TOO_MANY_IBANS = 'TOO_MANY_IBANS',
	PHONE_CHANGED_RECENTLY = 'PHONE_CHANGED_RECENTLY',
	IBAN_ALREADY_EXISTS = 'IBAN_ALREADY_EXISTS',

	// Divers
	QUESTIONS_MISSING = 'QUESTIONS_MISSING',
	FILE_MISSING = 'FILE_MISSING',
	DATE_FORMAT = 'DATE_FORMAT',
	JSON_FORMAT = 'JSON_FORMAT'
}

export const getMessageFromBusinessError = (be: BusinessError, $t): string => {
	switch (be) {
		case BusinessError.WALLET_INVALID:
			return $t('businessErrors.walletInvalid');
		case BusinessError.LEGAL_PERSON_IR:
			return $t('businessErrors.legalPersonIR');
		case BusinessError.DEFISC_IRPP_UNAVAILABLE:
			return $t('businessErrors.defiscIRPP');
		case BusinessError.LEGAL_PERSON_APPORT_CESSION:
			return $t('businessErrors.legalPersonApportCession');
		case BusinessError.DEFISC_APPORT_CESSION_UNAVAILABLE:
			return $t('businessErrors.defiscApportCession');
		case BusinessError.COUNTRY_NOT_ALLOWED:
			return $t('businessErrors.countryNotAllowed');
		case BusinessError.PAYMENT_TYPE_NOT_ALLOWED:
			return $t('businessErrors.paymentTypeNotAllowed');
		case BusinessError.PAYMENT_CARD_OVER_5000:
			return $t('businessErrors.paymentOver5000');
		case BusinessError.LEGAL_PERSON_PEA:
			return $t('businessErrors.legalPersonPEA');
		case BusinessError.PAYMENT_CHECK_UNDER_5000:
			return $t('businessErrors.paymentCheckUnder5000');
		case BusinessError.INCORRECT_AMOUNT:
			return $t('businessErrors.incorrectAmount');
		case BusinessError.ACCOUNT_NOT_FULLY_REGISTERED:
			return $t('businessErrors.accountNotRegistered');
		case BusinessError.ACCOUNT_NOT_LEGAL_AGE:
			return $t('businessErrors.notLegalAge');
		case BusinessError.ACCOUNT_DOCUMENTS_OUTDATED:
			return $t('businessErrors.updateDocs');
		case BusinessError.ACCOUNT_DOCUMENTS_NOT_YET_VALID:
			return $t('businessErrors.docsNotValid');
		case BusinessError.ACCOUNT_NOT_ALLOWED:
			return $t('businessErrors.accountNotAllowed');
		case BusinessError.PREMIUM_ONLY:
			return $t('businessErrors.premiumOnly');
		case BusinessError.NATURAL_PERSON_ONLY:
			return $t('businessErrors.naturalPersonOnly');
		case BusinessError.LEGAL_PERSON_ONLY:
			return $t('businessErrors.legalPersonOnly');
		case BusinessError.HOUSING_TAX_UNAVAILABLE:
			return $t('businessErrors.housingTaxUnavailable');
		case BusinessError.ACCOUNT_BLOCKED:
			return $t('businessErrors.accountBlocked');
		case BusinessError.ACCOUNT_BLOCKED_DATE:
			return $t('businessErrors.accountBlockedDate');
		case BusinessError.DEPARTMENT_NOT_ALLOWED:
			return $t('businessErrors.departmentNotAllowed');
		case BusinessError.FUNDING_NOT_OPEN:
			return $t('businessErrors.foundingNotOpen');
		case BusinessError.MAX_AMOUNT_REACHED:
			return $t('businessErrors.maxAmountReached');
		case BusinessError.MAX_AMOUNT_LEFT:
			return $t('businessErrors.maxAmountLeft');
		case BusinessError.MAX_AMOUNT_PREMIUM_LEFT:
			return $t('businessErrors.maxAmountPremiumLeft');
		case BusinessError.NO_INTENTION_QUEUE:
			return $t('businessErrors.noIntentionQueue');
		case BusinessError.CAN_NOT_CHANGE_INTENTION_QUEUE:
			return $t('businessErrors.cantChangeIntentionQueue');
		case BusinessError.ELAPSED_TIME:
			return $t('businessErrors.elapsedTime');
		case BusinessError.NOT_YOUR_TURN_IN_QUEUE:
			return $t('businessErrors.notYourTurnInQueue');
		case BusinessError.ALREADY_PAID:
			return $t('businessErrors.alreadyPaid');
		case BusinessError.INSUFFICIENT_BALANCE:
			return $t('businessErrors.insufficientBalance');
		case BusinessError.ID_EXPIRED:
			return $t('businessErrors.idExpired');
		case BusinessError.KYC_OUTDATED:
			return $t('businessErrors.kycOutdated');
		case BusinessError.CANNOT_CHANGE_IDENTITY:
			return $t('businessErrors.cantChangeID');
		case BusinessError.PROOF_OF_ADDRESS_MISSING:
			return $t('businessErrors.proofOfAddressMissing');
		case BusinessError.CANNOT_CHANGE_LEGAL_PERSON_PROFILE:
			return $t('businessErrors.cantChangeLegalPersonProfile');
		case BusinessError.ID_AND_PASSEPORT_NOT_DIFFERENT:
			return $t('businessErrors.idAndPasseportNotDifferent');
		case BusinessError.OBJECTIVES_B7_BAD_ANSWER:
			return $t('businessErrors.objectivesB7BadAnswered');
		case BusinessError.FINANCIAL_SITUATION_E5_BAD_ANSWER:
			return $t('businessErrors.financialSituationE5BadAnswered');
		case BusinessError.FINANCIAL_SITUATION_E6_BAD_ANSWER:
			return $t('businessErrors.financialSituationE6BadAnswered');
		case BusinessError.UNREADABLE_FILE:
			return $t('businessErrors.unreadableFile');
		case BusinessError.FRONT_AND_BACK_FILES_NOT_DIFFRENT:
			return $t('businessErrors.frontBackFilesDifferent');
		case BusinessError.CANNOT_CHANGE_LEGAL_PERSON_INFOS:
			return $t('businessErrors.cantChangeLegalPersonInfos');
		case BusinessError.CANNOT_CHANGE_KNOWLEDGE:
			return $t('businessErrors.cantChangeKnowledgeInfos');
		case BusinessError.MISSING_FRONT_FILE:
			return $t('businessErrors.missingFrontFile');
		case BusinessError.CANNOT_SEND_DOCUMENT:
			return $t('businessErrors.canNotSendDocument');
		case BusinessError.EMAIL_ALREADY_USED:
			return $t('businessErrors.emailAlreadyUsed');
		case BusinessError.OLD_PASSWORD_WRONG:
			return $t('businessErrors.oldPasswordWrong');
		case BusinessError.PASSWORD_WITH_PERSONAL_INFOS:
			return $t('businessErrors.passwordWithPersonalInfos');
		case BusinessError.NAME_MISSING:
			return $t('businessErrors.nameMissing');
		case BusinessError.QUESTIONS_MISSING:
			return $t('businessErrors.questionsMissing');
		case BusinessError.FILE_MISSING:
			return $t('businessErrors.fileMissing');
		case BusinessError.DATE_FORMAT:
			return $t('businessErrors.badeDateFormat');
		case BusinessError.JSON_FORMAT:
			return $t('businessErrors.badeJsonFormat');
		case BusinessError.INCOMPLETE_PROFILE:
			return $t('businessErrors.incompleteProfile');
		case BusinessError.KYC_PSI_OPC_OUTDATED:
			return $t('businessErrors.outdatedPSIOPCKyc');
		case BusinessError.KYC_PSI_OC_OUTDATED:
			return $t('businessErrors.outdatedPSIOCKyc');
		case BusinessError.KYC_PSI_TP_OUTDATED:
			return $t('businessErrors.outdatedPSITPKyc');
		case BusinessError.KYC_PSFP_OUTDATED:
			return $t('businessErrors.outdatedPSFPKyc');
		case BusinessError.KYC_PSI_OUTDATED:
			return $t('businessErrors.outdatedPSIKyc');
		case BusinessError.FISCAL_ADDRESS:
			return $t('businessErrors.updateFiscalAddress');
		case BusinessError.KYC_PSFP_FOR_OC:
			return $t('businessErrors.updatePSFPForOC');
		case BusinessError.EXPIRED_TOKEN:
			return $t('businessErrors.invalidToken');
		case BusinessError.MISSING_2FA:
			return $t('businessErrors.missing2fa');
		case BusinessError.TOO_MANY_IBANS:
			return $t('addIbanError.tooManyIbans');
		case BusinessError.PHONE_CHANGED_RECENTLY:
			return $t('addIbanError.phoneChangedRecently');
		case BusinessError.IBAN_ALREADY_EXISTS:
			return $t('addIbanError.ibanAlreadyExists');
	}
};

export const getBusinessErrorFromCode = (code: number): BusinessError | undefined => {
	switch (code) {
		case 1:
			return BusinessError.MISSING_2FA;
		case 100:
			return BusinessError.WALLET_INVALID;
		case 101:
			return BusinessError.LEGAL_PERSON_IR;
		case 102:
			return BusinessError.DEFISC_IRPP_UNAVAILABLE;
		case 103:
			return BusinessError.LEGAL_PERSON_APPORT_CESSION;
		case 104:
			return BusinessError.DEFISC_APPORT_CESSION_UNAVAILABLE;
		case 105:
			return BusinessError.COUNTRY_NOT_ALLOWED;
		case 106:
			return BusinessError.PAYMENT_TYPE_NOT_ALLOWED;
		case 107:
			return BusinessError.PAYMENT_CARD_OVER_5000;
		case 108:
			return BusinessError.LEGAL_PERSON_PEA;
		case 109:
			return BusinessError.PAYMENT_CHECK_UNDER_5000;
		case 110:
			return BusinessError.INCORRECT_AMOUNT;
		case 111:
			return BusinessError.ACCOUNT_NOT_FULLY_REGISTERED;
		case 112:
			return BusinessError.ACCOUNT_NOT_LEGAL_AGE;
		case 113:
			return BusinessError.ACCOUNT_DOCUMENTS_OUTDATED;
		case 114:
			return BusinessError.ACCOUNT_DOCUMENTS_NOT_YET_VALID;
		case 115:
			return BusinessError.ACCOUNT_NOT_ALLOWED;
		case 116:
			return BusinessError.PREMIUM_ONLY;
		case 117:
			return BusinessError.NATURAL_PERSON_ONLY;
		case 118:
			return BusinessError.LEGAL_PERSON_ONLY;
		case 119:
			return BusinessError.HOUSING_TAX_UNAVAILABLE;
		case 120:
			return BusinessError.ACCOUNT_BLOCKED;
		case 121:
			return BusinessError.ACCOUNT_BLOCKED_DATE;
		case 122:
			return BusinessError.DEPARTMENT_NOT_ALLOWED;
		case 123:
			return BusinessError.FUNDING_NOT_OPEN;
		case 124:
			return BusinessError.MAX_AMOUNT_REACHED;
		case 125:
			return BusinessError.MAX_AMOUNT_LEFT;
		case 126:
			return BusinessError.MAX_AMOUNT_PREMIUM_LEFT;
		case 127:
			return BusinessError.NO_INTENTION_QUEUE;
		case 128:
			return BusinessError.CAN_NOT_CHANGE_INTENTION_QUEUE;
		case 129:
			return BusinessError.ELAPSED_TIME;
		case 130:
			return BusinessError.NOT_YOUR_TURN_IN_QUEUE;
		case 131:
			return BusinessError.ALREADY_PAID;
		case 132:
			return BusinessError.INSUFFICIENT_BALANCE;
		case 133:
			return BusinessError.ID_EXPIRED;
		case 134:
			return BusinessError.KYC_OUTDATED;
		case 135:
			return BusinessError.INCOMPLETE_PROFILE;
		case 200:
			return BusinessError.CANNOT_CHANGE_IDENTITY;
		case 201:
			return BusinessError.PROOF_OF_ADDRESS_MISSING;
		case 202:
			return BusinessError.CANNOT_CHANGE_LEGAL_PERSON_PROFILE;
		case 203:
			return BusinessError.ID_AND_PASSEPORT_NOT_DIFFERENT;
		case 204:
			return BusinessError.OBJECTIVES_B7_BAD_ANSWER;
		case 205:
			return BusinessError.FINANCIAL_SITUATION_E5_BAD_ANSWER;
		case 206:
			return BusinessError.FINANCIAL_SITUATION_E6_BAD_ANSWER;
		case 207:
			return BusinessError.UNREADABLE_FILE;
		case 208:
			return BusinessError.FRONT_AND_BACK_FILES_NOT_DIFFRENT;
		case 209:
			return BusinessError.CANNOT_CHANGE_LEGAL_PERSON_INFOS;
		case 210:
			return BusinessError.CANNOT_CHANGE_KNOWLEDGE;
		case 211:
			return BusinessError.MISSING_FRONT_FILE;
		case 212:
			return BusinessError.CANNOT_SEND_DOCUMENT;
		case 213:
			return BusinessError.EMAIL_ALREADY_USED;
		case 214:
			return BusinessError.OLD_PASSWORD_WRONG;
		case 215:
			return BusinessError.PASSWORD_WITH_PERSONAL_INFOS;
		case 216:
			return BusinessError.NAME_MISSING;
		case 228:
			return BusinessError.KYC_PSFP_OUTDATED;
		case 229:
			return BusinessError.KYC_PSI_OUTDATED;
		case 233:
			return BusinessError.FISCAL_ADDRESS;
		case 234:
			return BusinessError.KYC_PSI_OPC_OUTDATED;
		case 235:
			return BusinessError.KYC_PSI_OC_OUTDATED;
		case 236:
			return BusinessError.KYC_PSI_TP_OUTDATED;
		case 237:
			return BusinessError.KYC_PSFP_FOR_OC;
		case 239:
			return BusinessError.FORCE_UPDATE_PASSWORD;
		case 240:
			return BusinessError.EXPIRED_TOKEN;
		case 300:
			return BusinessError.QUESTIONS_MISSING;
		case 301:
			return BusinessError.FILE_MISSING;
		case 302:
			return BusinessError.DATE_FORMAT;
		case 303:
			return BusinessError.JSON_FORMAT;
		case 400:
			return BusinessError.TOO_MANY_IBANS;
		case 401:
			return BusinessError.PHONE_CHANGED_RECENTLY;
		case 402:
			return BusinessError.IBAN_ALREADY_EXISTS;
	}
	return undefined;
};
